<template>
  <div class="timer-component-container">
    <div class="text">
      <div>TIMER</div>
      <div>{{ formattedTime }}</div>
    </div>
    <pie :fill="pie" />
  </div>
</template>

<script>
import Pie from '@components/singletons/pie';

export default {
  components: { Pie },
  props: {
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    seconds: {
      type: Number,
      default: 120,
    },
  },
  data() {
    return {
      radius: 13,
      time: 0,
      timer: null,
    };
  },
  computed: {
    formattedTime() {
      let date = new Date(null);
      date.setSeconds(this.time);
      return date.toISOString().substr(15, 4);
    },
    pie() {
      // scaling chart depends on diameter, time / seconds, and Pi
      let spacing = ((this.radius * 2) * this.time * Math.PI) / this.totalSeconds;
      return `${spacing} 100`;
    },
    totalSeconds() {
      return this.seconds + (this.flashcard.secondsPerQuestionDelta || 0);
    },
  },
  watch: {
  	flashcard: {
      immediate: true,
      handler: function(object) {
        if (object.id) {
          this.time = this.totalSeconds;
        }
      },
    },
  },
  mounted() {
    this.time = this.totalSeconds;
    this.$eventBus.$on('timer-start', this.start);
    this.$eventBus.$on('timer-stop', this.stop);
  },
  beforeUnmount() {
    this.$eventBus.$off('timer-start', this.start);
    this.$eventBus.$off('timer-stop', this.stop);
    this.stop();
  },
  methods: {
    start(timeExpired = 0) {
      const context = this;
      this.time = this.totalSeconds - timeExpired;

      this.timer = setInterval(function() {
        if(context.time > 0) {
          --context.time;
        } else {
          context.$eventBus.$emit('timer-end');
          clearInterval(context.timer);
        }
      }, 1000);
    },
    stop() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
  .timer-component-container {
    display: flex;
    margin-left: auto;

    .text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: rem-calc(12);
      text-align: right;

      div {
        &:first-child {
          font-size: rem-calc(12);
          font-weight: $semi-bold;
          letter-spacing: 1px;
        }

        &:last-child {
          font-size: rem-calc(18);
        }
      }
    }

    svg {
      height: rem-calc(40);
      width: rem-calc(40);
    }

    circle:first-child {
      fill: none;
      stroke: #247fdb;
    }

    circle:last-child{
      fill: none;
      stroke: #D6E5F6;
    }
  }
</style>
